export default "__VITE_ASSET__295b5775__"